import React from 'react'
import Sidebar from "../Sidebar";
import { useState, useEffect  } from 'react';
import axiosInstance from '../../helpers/axios';
import Topbar from "../Topbar";
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png"
import download from "../../assets/images/download.png"
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Mandatepausedreport() {
    const [isOpen,setIsOpen]=useState(true) 
    const [PuasedData, setPuasedData] = useState()
    const [PausedstartDate,setPausedStartDateFrom] = useState()
    const [pausedendDate,setPuasedEndDateTo] = useState()
    const [isLoading, setIsLoading] = useState(false); 


    const user = sessionStorage.getItem('user');


    useEffect(() => {
        
        setIsLoading(true)
    
        axiosInstance.get('/analytics/Paused-report', {
          headers: {
            Authorization: `Bearer ${user}`,
          },
         
        })
        .then((res) => {
           
          console.log(res?.data?.legalreports?.legalreport, 'datadfhgjhhj');
          const legaldatareport=res?.data?.pausedreports?.Puasedreport
          setPuasedData(legaldatareport)
          
          const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
          }, 300);

        })
        .catch((error) => {
          console.log(error);
        });
    
      }, []); 




      const fetchingclosedData = ()=>{

        setIsLoading(true)

        let queryParams = {}
        if(PausedstartDate && pausedendDate){
            
            const formattedStartDate = moment(PausedstartDate, 'DD MMM YYYY').format('DD-MM-YYYY')
            const formattedEndDate =moment(pausedendDate, 'DD MMM YYYY').format('DD-MM-YYYY')

            console.log(formattedStartDate , formattedEndDate,'datesssssss')
    
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
        }
        
       
    
        axiosInstance.get('/analytics/Paused-report', {
          params: queryParams,
          headers: {
            Authorization: `Bearer ${user}`,
          },
        })
        .then((res) => {
    
            setPuasedData(res?.data?.pausedreports?.Puasedreport);
        
            const loadingTimeout = setTimeout(() => {
                setIsLoading(false);
              }, 300);
         
        })
        .catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        });
       }


       function formatNumberWithCommas(number) {
        return number?.toLocaleString('en-IN'); 
      }





  return (
    <div style={{display:'flex',width:"100%",backgroundColor:'white',height:'130%'}}>
    <Sidebar isOpenSidebar={isOpen} handler={setIsOpen}/>
    <div style={{width:isOpen?'80%':'100%',marginLeft:isOpen?"20%":'0%',padding:'10px'}}>
    <Topbar/>



    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Paused Mandates </p>


    <div style={{ display: 'flex' }}>

<div style={{ height:'30px',width:'15em', borderRadius: '20px',marginRight:"60px",marginTop:'-2px'}}>
<DatePicker
style={{ height:'33px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat',
backgroundPosition: '5px center',
backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px", border:'1px solid #ccc',fontWeight:"normal", border:'1px solid #ccc'}}
placeholder="Select date range"
allowClear={true}
format="DD MMM YYYY"
onChange={(dates, dateStrings) => {
 console.log("dateStrings:", dateStrings);

   
 setPausedStartDateFrom(dateStrings?.validatedValue[0])
 setPuasedEndDateTo(dateStrings?.validatedValue[1])
}}
range
/>
</div>

<div > 
<button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
onClick={() => fetchingclosedData()}
>
Search Results
</button>
</div>

</div>

  {isLoading ? (
                  <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                  <CircularProgress />
                </Box>
                ):(<>
    <table className='tables' style={{marginRight:'10px'}}>
        
  <thead className='table-heading'>
    <tr>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '15px' }}>Loan id</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Cust name</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>inst name</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Mobile</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Loan amount</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '15px%', fontFamily: "Inter-Medium" }}>outstandingAmount</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Paused date</th>
      <th style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Emi's count</th>
      
      
     
    </tr>
  </thead>
  
  
  <tbody className='table-body'>
  {
    PuasedData?.map((item, index) => (
       
      <tr className="table-row" key={index} style={{ lineHeight:"25px"}}>
        {console.log(item?.mobile,'mobillllllll')}
       <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '8px' }}>{item?.legacy_loan_id?item?.legacy_loan_id:'-'}</td>
       <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '8px' }}>{item?.customer_name?item?.customer_name:'-'}</td>
       <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item?.name?item?.name:'-'}</td>
       <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item?.mobile?item?.mobile:'-'}</td>
        <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{item?.loan_amount ?formatNumberWithCommas(Math.round(item?.loan_amount)):'-'}</td>
        <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{item?.total_principle_amount ?formatNumberWithCommas(Math.round(item?.total_principle_amount)):'-'}</td>
        <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item?.updated_at ?item?.updated_at  : '-'}</td> 
        <td style={{ fontSize: '0.9vw', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item?.emi_count?item?.emi_count  : '-'}</td> 

      </tr> 
    ))}
  </tbody>
</table></>)}

    </div>
    </div>
  
  )
}
